import { CheckOutlined, CloseOutlined, SaveOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, Form, Input, Row, Select, Switch, Upload } from 'antd';
import type { UploadFile, UploadProps } from 'antd/es/upload/interface';
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import ModalTextForm from "../../components/modal/ModalTextForm";
import { responseStatus, urlAdmin } from "../../constants";
import { dateCommon, validateMessages } from "../../helpers/common";
import { BacLuongResponse, HopDong, HopDongRequest } from "../../models/hopdong/HopDong";
import { TaiLieu } from '../../models/nhanvien/TaiLieu';
import { DataSelectBox } from "../../models/selectbox";
import { convertDataSelectBox, layDanhMucLoaiHopDong } from "../../services/danhmuc";
import { layDsQDBLTheoIdNhanVien, luuHopDong } from "../../services/hopdong";
const { TextArea } = Input;

const XemHopDongBox = ({ title, idNhanVien, show, onClose, onSubmit, modelProps }: { title: string, idNhanVien: number, show: boolean, onClose: () => void, onSubmit: () => void, modelProps: HopDong | null }) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [stateHD, setStateHD] = useState<boolean>(false);
    const [stateDongBHXH, setStateDongBHXH] = useState<boolean>(false);

    const [optionLoaiHopDong, setOptionLoaiHopDong] = useState<Array<DataSelectBox>>([]);
    const [idsTaiLieuHopDongXoa, setIdsTaiLieuHopDongXoa] = useState<Array<number>>([]);

    const isThemMoi = !modelProps?.id;
    const [dsQDBL, setDsQDBL] = useState<BacLuongResponse[]>([]);
    const [idQDBlCu, setIdQDBlCu] = useState<number | null>(null);

    var fileHienTai: any = (modelProps?.dsTaiLieu || []).map((item: TaiLieu) => {
        return {
            uid: item.idTaiLieu + "tailieu", 
            name: item.tenTep,
            status: 'done',
            url: urlAdmin + item.duongDan.replace(/\\/g, "/"),
            //url: item.duongDan.replace("View\\public", urlAdmin).replace(/\\/g, "/"),
        };
    });
    const [fileList, setFileList] = useState<UploadFile[]>(fileHienTai);
    const [form] = Form.useForm();

    const setFormDetailModal = (value: HopDong | null) => {        
        form.setFieldsValue({
            idNhanVien: idNhanVien,
            id: value?.id,
            idLoaiHopDong: value?.idLoaiHopDong,
            soHopDong: value?.soHopDong,
            noiKy: value?.noiKy,
            tenNguoiKy: value?.tenNguoiKy,
            isDongBHXH: value?.isDongBHXH,
            trangThai: value?.trangThai,
            noiDung: value?.noiDung,
            ngayKy: value?.ngayKy ? dayjs(dateCommon.formatDate(value?.ngayKy), "DD/MM/YYYY") : null,
            ngayBatDau: value?.ngayBatDau ? dayjs(dateCommon.formatDate(value?.ngayBatDau), "DD/MM/YYYY") : null,
            ngayKetThuc: value?.ngayKetThuc ? dayjs(dateCommon.formatDate(value?.ngayKetThuc), "DD/MM/YYYY") : null
        });
        setStateDongBHXH(value?.isDongBHXH || false);
        setStateHD(value?.trangThai === 1 ? true : false || false);
    }

    const props: UploadProps = {
        onRemove: (file) => {
            if (file.uid.includes("tailieu")) {
                var id = parseInt(file.uid.split("tailieu")[0]);
                setIdsTaiLieuHopDongXoa([...idsTaiLieuHopDongXoa, id]);
            }
            const index = fileList.indexOf(file);
            const newFileList = fileList.slice();
            newFileList.splice(index, 1);
            setFileList(newFileList);
        },
        beforeUpload: (file) => {
            const maxSize = 20000000; // 20 MB
            if (file.size > maxSize) {
                alert('Tệp tin đính kèm không được vượt quá 20MB');
            } else {
                setFileList([...fileList, file]);
            }
            return false;
        },
        fileList,
    };
    const loadDataSelectBoxs = async () => {
        try {
            setIsLoading(true);

            var loaiHopDong = await layDanhMucLoaiHopDong();
            setOptionLoaiHopDong(convertDataSelectBox(loaiHopDong));

            if (isThemMoi) {
                var resQDBL = await layDsQDBLTheoIdNhanVien(idNhanVien);
                const ds: BacLuongResponse[] = resQDBL || [];
                setDsQDBL(ds);

                const qdblHienHanh = ds[0];
                setIdQDBlCu(qdblHienHanh?.idQuyetDinhBacLuong ?? null);
            }

            setIsLoading(false);
        }
        catch (err: any) {
            setIsLoading(false);
        }
    }

    const onFinish = async (values: any) => {
        setIsLoading(true);
        var ngayBatDau = dateCommon.formatDate(values.ngayBatDau?.$d);
        var ngayKetThuc = dateCommon.formatDate(values?.ngayKetThuc?.$d);
        var ngayKy = dateCommon.formatDate(values.ngayKy?.$d);
        
        var request: HopDongRequest = {
            files: fileList,
            id:  modelProps?.id || null,
            tenNguoiKy: values.tenNguoiKy,
            idNhanVien: idNhanVien,
            idLoaiHopDong: values.idLoaiHopDong,
            soHopDong: values.soHopDong,
            ngayBatDau: ngayBatDau,
            ngayKetThuc: ngayKetThuc,
            ngayKy: ngayKy,
            trangThai: values.trangThai,
            noiDung: values.noiDung,
            isDongBHXH: values.isDongBHXH,
            noiKy: values.noiKy,
            idsTaiLieuHopDongXoa: idsTaiLieuHopDongXoa,
            idQDBLCu: isThemMoi ? idQDBlCu : null,
            idHopDongDienTu: modelProps?.idHopDongDienTu || 0
        }
        var response: any = await luuHopDong(request);

        if (response.trangThai === responseStatus.thanhCong) {
            toast.success('Lưu hợp đồng/QĐ bổ nhiệm thành công');
        } else {
            toast.error(response.thongBao);
        }

        setIsLoading(false);
        onClose();
        onSubmit();
    };

    useEffect(() => {
        loadDataSelectBoxs();
        setFormDetailModal(modelProps);
    }, []);
    return (
        <ModalTextForm
            show={show} hideFooter
            size="xl"
            title={title}
            handleClose={() => {
                if (!isLoading) {
                    onClose();
                }
            }}
            handleSave={() => { setIsLoading(true) }}>
            <Row>
                <Col span="24">
                    <Form layout="vertical" onFinish={onFinish} validateMessages={validateMessages} form={form}>
                        <Row gutter={16}>
                            <Col className="gutter-row" span="12">
                                <Form.Item name="soHopDong" label="Số hợp đồng/QĐ bổ nhiệm"
                                    rules={[
                                        {
                                            required: true,
                                        },
                                        {
                                            min: 0,
                                        },
                                        {
                                            max: 50,
                                        }
                                    ]}>
                                    <Input
                                        placeholder="Số hợp đồng/QĐ bổ nhiệm"
                                    />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span="12">
                                <Form.Item name="idLoaiHopDong" label="Loại hợp đồng/QĐ bổ nhiệm"
                                    rules={[
                                        {
                                            required: true,
                                        },                                        
                                    ]}>
                                    <Select notFoundContent="Không có dữ liệu" options={optionLoaiHopDong} loading={isLoading} placeholder="Loại hợp đồng/QĐ bổ nhiệm" />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span="12">
                                <Form.Item
                                    name="ngayKy"
                                    label="Ngày ký"
                                    rules={[{ required: true }]}>
                                    <DatePicker changeOnBlur={true} style={{ width: "100%" }} placeholder="Ngày ký hợp đồng/QĐ bổ nhiệm" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span="12">
                                <Form.Item name="noiKy" label="Nơi ký">
                                    <Input
                                        placeholder="Nơi ký"
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span="12">
                                <Form.Item
                                    name="ngayBatDau"
                                    label="Ngày bắt đầu"
                                    rules={[{ required: true }]}>
                                    <DatePicker changeOnBlur={true} style={{ width: "100%" }} placeholder="Ngày bắt đầu" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                                </Form.Item>
                            </Col>
                            <Col span="12">
                                <Form.Item
                                    name="ngayKetThuc"
                                    label="Ngày kết thúc">
                                    <DatePicker changeOnBlur={true} style={{ width: "100%" }} placeholder="Ngày kết thúc" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col className="gutter-row" span="12">
                                <Form.Item name="tenNguoiKy" label="Người ký">
                                    <Input
                                        placeholder="Người ký"
                                    />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span="6">
                                <Form.Item name="isDongBHXH" label="Đóng bảo hiểm xã hội">
                                    <>
                                        <Switch checked={stateDongBHXH} checkedChildren={<CheckOutlined rev="" />} unCheckedChildren={<CloseOutlined rev="" />} onChange={(e) => { setStateDongBHXH(e); form.setFieldsValue({ isDongBHXH: e }) }} />
                                    </>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span="6">
                                <Form.Item name="trangThai" label="Trạng thái">
                                    <>
                                        <Switch checked={stateHD} checkedChildren={<CheckOutlined rev="" />} unCheckedChildren={<CloseOutlined rev="" />} onChange={(e) => { setStateHD(e); form.setFieldsValue({ trangThai: e === true ? 1 : 0 }) }} />
                                    </>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col span="24">
                                <Form.Item name="noiDung" label="Nội dung">
                                    <TextArea rows={4} placeholder="Nội dung" />
                                </Form.Item>
                            </Col>
                        </Row>
                        {isThemMoi && (
                            <Row gutter={16}>
                                <Col span="24">
                                    <Form.Item label="Quyết định bậc lương áp dụng">
                                        <div style={{ marginBottom: 8 }}>
                                            <Switch
                                                checked={idQDBlCu !== null}
                                                onChange={(checked) => {
                                                    if (!checked) {
                                                        setIdQDBlCu(null);
                                                    } else {
                                                        // Tự động chọn QĐBL đầu tiên (hiện hành)
                                                        setIdQDBlCu(dsQDBL[0]?.idQuyetDinhBacLuong ?? null);
                                                    }
                                                }}
                                                checkedChildren="Có áp dụng"
                                                unCheckedChildren="Không áp dụng"
                                            />
                                            <span style={{ marginLeft: 8, color: '#999' }}>
                                                {idQDBlCu !== null ? 'Áp dụng QĐBL từ hợp đồng cũ' : 'Không áp dụng QĐBL cũ'}
                                            </span>
                                        </div>
                                        <Select
                                            value={idQDBlCu}
                                            disabled={idQDBlCu === null}
                                            loading={isLoading}
                                            placeholder="Chọn quyết định bậc lương"
                                            notFoundContent="Không có dữ liệu"
                                            onChange={(value) => setIdQDBlCu(value ?? null)}
                                            options={dsQDBL.map((item) => ({
                                                value: item.idQuyetDinhBacLuong,
                                                label: `Số QĐ: ${item.soQD ?? "-Trống-"} - Hệ số ${item.heSo} - Bắt đầu từ: ${dateCommon.formatDate(item.ngayBatDau)} - Tên: ${item.tenBacLuong}`
                                            }))}
                                        />
                                        <small style={{ color: '#999', display: 'block', marginTop: 4 }}>
                                            {idQDBlCu !== null
                                                ? 'Bật switch ở trên để áp dụng QĐBL. Có thể thay đổi QĐBL khác từ danh sách.'
                                                : 'Bật switch ở trên nếu muốn áp dụng QĐBL từ hợp đồng cũ.'}
                                        </small>
                                    </Form.Item>
                                </Col>
                            </Row>
                        )}
                        <Row>
                            <Col span="24">
                                <Upload {...props}>
                                    <Button icon={<UploadOutlined rev="" />}>Thêm file</Button>
                                </Upload>
                            </Col>
                        </Row>
                        <Form.Item>
                            <Button className="float-right mt-2" type="primary" htmlType="submit" loading={isLoading} icon=<SaveOutlined rev="" />>
                                Lưu
                            </Button>
                        </Form.Item>
                    </Form>
                </Col>
            </Row>
        </ModalTextForm>
    );
};

export default XemHopDongBox;